// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListingIntro-listIntroGridWrapper-iqgkh {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 24px;
}

.ListingIntro-gridBoxSection-NqCKq {
	background: var(--common-gray-bg-color);
	border: 1px solid var(--search-input-border);
	border-radius: 12px;
	padding: 24px;
	text-align: center;
}

.ListingIntro-gridColumn-gPYQx {
	display: grid;
	grid-template-columns: 70% auto;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 15px;
}

.ListingIntro-textSection-X087l {
	word-break: break-word;
}

.ListingIntro-mobileMargin-a__J7 {
	text-align: center;
}

.ListingIntro-listingIntroImage-bllhA {
	width: 100%;
    max-width: 36px;
    min-width: 36px;
    height: 36px;
    min-height: 36px;
	-o-object-fit: contain;
	   object-fit: contain;
}

@media screen and (max-width: 991px) {
	.ListingIntro-listIntroGridWrapper-iqgkh {
		grid-template-columns: repeat(3, 1fr);
	}
}

@media screen and (max-width: 767px) {
	.ListingIntro-listIntroGridWrapper-iqgkh {
		grid-template-columns: 100%;
	}

	.ListingIntro-mobileMargin-a__J7 {
		margin-top: 18px;
	}

	.ListingIntro-gridColumn-gPYQx {
		grid-template-columns: 100%;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/ListingIntro/ListingIntro.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;;AAEA;CACC,uCAAuC;CACvC,4CAA4C;CAC5C,mBAAmB;CACnB,aAAa;CACb,kBAAkB;AACnB;;AAGA;CACC,aAAa;CACb,+BAA+B;CAC/B,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;IACR,eAAe;IACf,eAAe;IACf,YAAY;IACZ,gBAAgB;CACnB,sBAAmB;IAAnB,mBAAmB;AACpB;;AACA;CACC;EACC,qCAAqC;CACtC;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,2BAA2B;CAC5B;AACD","sourcesContent":[".listIntroGridWrapper {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(4, 1fr);\n\tgap: 24px;\n}\n\n.gridBoxSection {\n\tbackground: var(--common-gray-bg-color);\n\tborder: 1px solid var(--search-input-border);\n\tborder-radius: 12px;\n\tpadding: 24px;\n\ttext-align: center;\n}\n\n\n.gridColumn {\n\tdisplay: grid;\n\tgrid-template-columns: 70% auto;\n\tjustify-content: space-between;\n\talign-items: center;\n\tgap: 15px;\n}\n\n.textSection {\n\tword-break: break-word;\n}\n\n.mobileMargin {\n\ttext-align: center;\n}\n\n.listingIntroImage {\n\twidth: 100%;\n    max-width: 36px;\n    min-width: 36px;\n    height: 36px;\n    min-height: 36px;\n\tobject-fit: contain;\n}\n@media screen and (max-width: 991px) {\n\t.listIntroGridWrapper {\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.listIntroGridWrapper {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.mobileMargin {\n\t\tmargin-top: 18px;\n\t}\n\n\t.gridColumn {\n\t\tgrid-template-columns: 100%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listIntroGridWrapper": `ListingIntro-listIntroGridWrapper-iqgkh`,
	"gridBoxSection": `ListingIntro-gridBoxSection-NqCKq`,
	"gridColumn": `ListingIntro-gridColumn-gPYQx`,
	"textSection": `ListingIntro-textSection-X087l`,
	"mobileMargin": `ListingIntro-mobileMargin-a__J7`,
	"listingIntroImage": `ListingIntro-listingIntroImage-bllhA`
};
module.exports = ___CSS_LOADER_EXPORT___;
